import React, { useMemo, useState } from 'react';
import { Input, Select, Button, Tag } from 'antd';
import CommonTable from 'components/CommonTable';
import { auditLog, AuditEntry } from '../mockData';
import s from './s.module.less';

const GPAuditLogPage: React.FC = () => {
    const [search, setSearch] = useState('');
    const [actionFilter, setActionFilter] = useState('');

    const actionOptions = useMemo(() => {
        const actions = [...new Set(auditLog.map((e) => e.action))];
        return [
            { label: 'All actions', value: '' },
            ...actions.map((a) => ({ label: a, value: a })),
        ];
    }, []);

    const filteredData = useMemo(() => {
        return auditLog.filter((entry) => {
            const matchSearch = !search || entry.user.toLowerCase().includes(search.toLowerCase());
            const matchAction = !actionFilter || entry.action === actionFilter;
            return matchSearch && matchAction;
        });
    }, [search, actionFilter]);

    const columns = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val: string) => <span className={s.mono}>{val}</span>,
        },
        {
            title: 'User',
            key: 'user',
            render: (_: unknown, record: AuditEntry) => (
                <div className={s.userCell}>
                    <div className={s.userName}>{record.user}</div>
                    <div className={s.userRole}>{record.userRole}</div>
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (val: string) => <Tag color="default">{val}</Tag>,
        },
        {
            title: 'Target',
            dataIndex: 'target',
            key: 'target',
            render: (val: string) => <span className={s.mono}>{val}</span>,
        },
        {
            title: 'IP',
            dataIndex: 'ip',
            key: 'ip',
            render: (val: string) => <span className={s.mono}>{val}</span>,
        },
        {
            title: 'User Agent',
            dataIndex: 'userAgent',
            key: 'userAgent',
        },
    ];

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <h2>Audit Log</h2>
                <Button>Export CSV</Button>
            </div>
            <div className={s.filters}>
                <Input
                    className={s.searchInput}
                    placeholder="Search by user"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    allowClear
                />
                <Select
                    className={s.actionSelect}
                    placeholder="Filter by action"
                    value={actionFilter}
                    onChange={setActionFilter}
                    options={actionOptions}
                />
            </div>
            <CommonTable<AuditEntry>
                data={filteredData}
                columns={columns}
                rowKey="id"
                pagination={false}
            />
        </div>
    );
};

export default GPAuditLogPage;
